import { render, staticRenderFns } from "./TagBoard.vue?vue&type=template&id=38b2b2bc&scoped=true&"
import script from "./TagBoard.vue?vue&type=script&lang=js&"
export * from "./TagBoard.vue?vue&type=script&lang=js&"
import style0 from "./TagBoard.vue?vue&type=style&index=0&id=38b2b2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2b2bc",
  null
  
)

component.options.__file = "TagBoard.vue"
export default component.exports